/**
 * Centralized logout utility that clears all authentication-related data
 * including impersonation state and redirects to login page
 */
export const logout = () => {
  // Inform other parts of the app (e.g., StatusBar) to skip unsaved-changes
  // prompts while we are programmatically logging the user out.
  if (typeof window !== 'undefined') {
    window.skipUnsavedChangesPrompt = true;
  }
  try {
    // Clear all authentication-related items from localStorage
    localStorage.removeItem('rechargeSession');
    localStorage.removeItem('shopifyCustomerAccessToken');
    localStorage.removeItem('impersonationState');
    localStorage.removeItem('hasActiveSubscriptions');
    localStorage.removeItem('loginRedirectTarget'); // Clean up redirect target
  } catch (err) {
    console.warn('Failed to clear some localStorage items during logout', err);
  }
  
  // Redirect to login page
  window.location.href = '/login';
}; 